import React from "react";
import MuiMenuItem from "@mui/material/MenuItem";
import PropTypes from "prop-types";

/**
 * MenuItem component wrapper for menu items.
 * Wraps Material-UI MenuItem with theme integration.
 * 
 * @component
 * @example
 * <MenuItem value={10}>Ten</MenuItem>
 * <MenuItem onClick={handleClick}>Profile</MenuItem>
 */
const MenuItem = ({ children, ...props }) => {
  return <MuiMenuItem {...props}>{children}</MuiMenuItem>;
};

MenuItem.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * If true, the list item will be focused during the first mount
   */
  autoFocus: PropTypes.bool,
  /**
   * If true, the list item will be disabled
   */
  disabled: PropTypes.bool,
  /**
   * If true, the left and right padding is removed
   */
  disableGutters: PropTypes.bool,
  /**
   * If true, a 1px light border is added to the bottom of the menu item
   */
  divider: PropTypes.bool,
  /**
   * If true, the list item will be selected
   */
  selected: PropTypes.bool,
  /**
   * The value of the menu item
   */
  value: PropTypes.any,
  /**
   * Callback fired when the menu item is clicked
   */
  onClick: PropTypes.func,
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI MenuItem behavior

export default MenuItem;

